import { IRouteModule, INavLink, INavLinks, IRoutes } from './../../types'
import { UserTypes } from 'src/modules/Auth/store/types';
import { validateAuthentication } from 'src/modules/Auth/helpers/validateAuthentication';
import { linkModuleSidebars } from 'src/modules/Routing/hooks/sideBars/linkSidebars';

const isAuthorized = (userType: UserTypes, navbar: string, routes: IRoutes[]) => {
  const linkRoute = routes.find(route => {
    const path = route.paths.find(componentPath => componentPath === navbar);
    return !!path;
  });
  if (linkRoute) {
    const { authorized } = validateAuthentication(userType, linkRoute.policies);
    if (authorized) {
      return true;
    }
  }
  return false
}

export const linkNavs = (modules: IRouteModule[], userType: UserTypes): INavLinks => {
  return modules.reduce((linkedRoutes, module) => {
    if (module.navbar && isAuthorized(userType, module.navbar, module.routes)) {
      const link: INavLink = {
        module: module.name,
        route: module.navbar,
        sidebar: linkModuleSidebars(module, userType)
      }
      if (module.settingsNavbar) {
        linkedRoutes.settings.push(link)
      } else {
        linkedRoutes.body.push(link)
      }
    }
    return linkedRoutes;
  }, { settings: [], body: [] } as INavLinks)
}
